import React from 'react';
import { Button, Grid, Header, HeaderSubheader, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';
import download from 'downloadjs';
import { FormattedMessage } from 'react-intl';
import { IconHeader, RightHeaderWithButton } from '../../Assets/util/css';
import { ExportReactCSV } from '../../util/ExportCSV';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from "../../util/PaginationFront";
import { fetchStudyType } from '../../Lookups/util';
import ReactExport from 'react-data-export';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p><FormattedMessage id="professorStatistics.noRegisteredStudents" /></p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;


export default class RegisteredStudents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            activeRegistration: null,
            // types:[],

            isLoading: false,
            results: [],
            value: '',

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
            excelData: []
        };

        this.getStudents = this.getStudents.bind(this);
        this.cancelExamRegistration = this.cancelExamRegistration.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    componentDidMount() {
        if(this.props.studentService){
            let closeRegistrationDay = moment(parseInt(localStorage.getItem('gradedActivityDate'), 10))
                .subtract(parseInt(localStorage.getItem('gradedActivityRegistrationClosing'), 10), 'days')
                .startOf('day');

            if (closeRegistrationDay < moment()) { this.setState({ activeRegistration: false }); } else { this.setState({ activeRegistration: true }); }
        }else{
            let closeRegistrationDay = moment(this.props.location ? this.props.location.state.exam.gradedActivityDate : parseInt(localStorage.getItem('gradedActivityDate'), 10))
                .subtract(this.props.location ? this.props.location.state.exam.gradedActivityRegistrationClosing : parseInt(localStorage.getItem('gradedActivityRegistrationClosing'), 10), 'days')
                .startOf('day');

            if (closeRegistrationDay < moment()) { this.setState({ activeRegistration: false }); } else { this.setState({ activeRegistration: true }); }
        }
        // fetchStudyType().then(
        //     (types)=>{
        //         this.setState({types: types.data})
        //     }
        // )



        axios.get(`student-exams/${this.props.location ? this.props.location.state.exam.gradedActivityId : localStorage.getItem('gradedActivityId')}`)
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el,
                        // studyType: this.state.types.find(e=> e.id === el.studyTypeId).displayName,
                        applicationDateFormated: el.applicationDate ? moment(el.applicationDate).format('D. M. YYYY.') : '',
                        studyProgramDisplayName: el.studyProgramBasicName ? el.studyProgramBasicName : el.departments ? el.departments[0].name : el.studyProgramName
                    })),
                    loading: false
                });
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName },
                    { value: el.index },
                    { value: el.departments ? el.departments[0].name: '' },
                    { value: el.studyProgramBasicName },
                    { value: el.studyProgramName },
                    { value: el.applicationDate ? moment(el.applicationDate).format('D. M. YYYY.') : '' },
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                console.log('Failed to fetch registered students.');
            });
    }

    getStudents() {
        let obj = {
            gradedActivityId: this.props.location ? this.props.location.state.exam.gradedActivityId : localStorage.getItem('gradedActivityId'),
            language: 'bs'
        };
        axios({
            method: 'post',
            url: '/documents/graded-activity-students',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }

    cancelExamRegistration(optLock, id) {
        let obj = {
            optLock, id
        };
        axios.delete('/student-exams/delete-registration', { data: obj })
            .then(res => {
                this.setState({ data: res.data, loading: false });
                toast('Prijava ispita je obrisana.');
            })
            .catch(err => {
                console.log('Failed to fetch registered students.');
                toast('Došlo je do greške! Prijava ispita nije obrisana.');
            });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }


    render() {
        const headersForExport = [
            { label: 'Prezime', key: 'lastName' },
            { label: 'Ime', key: 'firstName' },
            { label: 'Index', key: 'index' },
            { label: 'Odsjek', key: 'departments[0].name' },
            { label: 'Studijski program', key: 'studyProgramBasicName' },
            { label: 'Plan i program', key: 'studyProgramName' },
            // { label: 'Tip studiranja', key: 'studyType' },
            { label: 'Datum prijave ispita', key: 'applicationDateFormated' },
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 300 } },
                    { title: 'Studijski program', width: { wpx: 300 } },
                    { title: 'Plan i program', width: { wpx: 300 } },
                    { title: 'Datum prijave ispita', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);



        const { data } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        if (this.props.studentService) {
            return (
                <div>
                    {this.state.activeRegistration ? <Header as="h6" color="blue"> <FormattedMessage id="professorStatistics.notFinalRegisteredStudentsList" /></Header> : ''}
                    {currentPosts.length ?
                        <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row verticalAlign="middle">
                                    <Table.HeaderCell colSpan={11} >
                                            <span>
                                                <Grid stackable columns={3} >

                                                         <Grid.Column width={12}>
                                                         {/*<SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgram', 'studyType', 'markName', 'grade']} />*/}
                                                         <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgram', 'markName', 'grade', 'studyProgramName', 'studyProgramBasicName']} />
                                                      </Grid.Column>
                                                      <Grid.Column width={2} style={{paddingRight: '5px'}}>
                                                          {localStorage.getItem('gradedActivityName') !== 'komisijski ispit' &&

                                                          <Popup
                                                              trigger={
                                                                  <Button
                                                                      animated="vertical"
                                                                      color="red"
                                                                      basic
                                                                      fluid
                                                                      onClick={this.getStudents}
                                                                  >
                                                                      <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                      <Button.Content visible>
                                                                          PDF
                                                                      </Button.Content>
                                                                  </Button>
                                                              }
                                                              content="Preuzmi spisak u PDF-u"
                                                              hideOnScroll
                                                              position="top center"
                                                          />}
                                                           </Grid.Column>
                                                      <Grid.Column width={2} style={{paddingLeft: '5px'}}>

                                                        {currentPosts &&
                                                        <ExcelFile filename="Spisak prijavljenih studenata" element={<Popup
                                                            trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                                <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                <Button.Content visible>
                                                                    Excel
                                                                </Button.Content>
                                                            </Button>}
                                                            content="Preuzmi spisak u Excel-u"
                                                            hideOnScroll
                                                            position="top center"
                                                        />}>
                                                            <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                                        </ExcelFile>
                                                        // <ExportReactCSV
                                                        //     color="green"
                                                        //     csvData={this.getDataToRender()}
                                                        //     headers={headersForExport}
                                                        //     fileName="Spisak prijavljenih studenata"
                                                        //     fluid
                                                        // />
                                                        }

                                                      </Grid.Column>
                                                </Grid>
                                            </span>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={1} width="1"><FormattedMessage id="common.ordinal" /></Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3}><FormattedMessage id="common.studentLastNameAndFirstName" /></Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}><FormattedMessage id="common.department" /></Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3}><FormattedMessage id="common.studyProgram" /></Table.HeaderCell>
                                    {/*<Table.HeaderCell colSpan={2}><FormattedMessage id="common.studyType" /></Table.HeaderCell>*/}
                                    <Table.HeaderCell colSpan={2}><FormattedMessage id="common.applicationDate" /></Table.HeaderCell>
                                    {/* {localStorage.getItem('grades') ? null : <Table.HeaderCell/>} */}
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {currentPosts.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell colSpan={1} verticalAlign="middle">
                                        {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        <Grid columns={1} centered className="stackable">
                                            <Grid.Row verticalAlign="middle">
                                                <Grid.Column width="10">
                                                    <span >{el.lastName} {el.firstName}</span>
                                                </Grid.Column>
                                                <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                    {/*<span style={{ color: '#a6a4a1' }}>{el.index}</span>*/}
                                                    <span style={{ color: '#a6a4a1' }}>{el.index}</span>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        {/*{el.studentLastName} {el.studentFirstName}*/}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.departments.map(el => (<div>{el.name}</div>))}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                        {/*{el.studyProgramBasicName ? el.studyProgramBasicName : el.departments ? el.departments.map(e => <div>{e.name}</div>) : el.studyProgramName}*/}
                                       {/*{ el.studyProgramDisplayName}*/}
                                    </Table.Cell>
                                    {/*<Table.Cell colSpan={2} verticalAlign="middle">*/}
                                    {/*    {el.studyType}*/}
                                    {/*</Table.Cell>*/}
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.applicationDate ? moment(el.applicationDate).format('D. M. YYYY.') : ''}
                                    </Table.Cell>
                                    {/* {localStorage.getItem('grades') ? null : <Table.Cell verticalAlign="middle" textAlign='center'> */}
                                    {/* <Button color='red' basic='true' onClick={() => this.cancelExamRegistration(el.optlock, el.studentGradedActivityId)}> */}
                                    {/* Odjavi ispit</Button> */}
                                    {/* </Table.Cell>} */}
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                        : <NoDataMessage />
                    }
                    {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                </div>
            );
        }

        return (
            <div>
                <Header as="h1">
                    <FormattedMessage id="student.registeredStudentsList" />
                </Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                {this.props.location ? this.props.location.state.exam.courseImplementationName : localStorage.getItem('courseImplementationName')}
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader>
                                {this.props.location ? this.props.location.state.exam.gradedActivityName + ' / ' + moment(this.props.location.state.exam.gradedActivityDate).format('D. M. YYYY. - HH:mm') : localStorage.getItem('gradedActivityName')}
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        {this.state.activeRegistration ? <Header as="h6" color="blue"> <FormattedMessage id="professorStatistics.notFinalRegisteredStudentsList" /></Header> : ''}
                        {currentPosts.length ?
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row verticalAlign="middle">
                                        <Table.HeaderCell colSpan={11} >
                                            <span>
                                                <Grid stackable columns={3} >

                                                         <Grid.Column width={12}>
                                                         {/*<SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgram', 'studyType', 'markName', 'grade']} />*/}
                                                         <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgram', 'markName', 'grade', 'studyProgramBasicName', 'studyProgramName']} />
                                                      </Grid.Column>
                                                      <Grid.Column width={2} style={{paddingRight: '5px'}}>
                                                          {localStorage.getItem('gradedActivityName') !== 'komisijski ispit' &&

                                                          <Popup
                                                              trigger={
                                                                  <Button
                                                                      animated="vertical"
                                                                      color="red"
                                                                      basic
                                                                      fluid
                                                                      onClick={this.getStudents}
                                                                  >
                                                                      <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                      <Button.Content visible>
                                                                          PDF
                                                                      </Button.Content>
                                                                  </Button>
                                                              }
                                                              content="Preuzmi spisak u PDF-u"
                                                              hideOnScroll
                                                              position="top center"
                                                          />}
                                                           </Grid.Column>
                                                      <Grid.Column width={2} style={{paddingLeft: '5px'}}>
                                                        {currentPosts &&
                                                        <ExcelFile filename="Spisak prijavljenih studenata" element={<Popup
                                                            trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                                <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                <Button.Content visible>
                                                                    Excel
                                                                </Button.Content>
                                                            </Button>}
                                                            content="Preuzmi spisak u Excel-u"
                                                            hideOnScroll
                                                            position="top center"
                                                        />}>
                                                            <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                                        </ExcelFile>
                                                        // <ExportReactCSV
                                                        //     color="green"
                                                        //     csvData={this.getDataToRender()}
                                                        //     headers={headersForExport}
                                                        //     fileName="Spisak prijavljenih studenata"
                                                        //     fluid
                                                        // />
                                                        }
                                                      </Grid.Column>
                                                </Grid>
                                            </span>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={1} width="1">R. br.</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={3}><FormattedMessage id="common.studentLastNameAndFirstName" /></Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}><FormattedMessage id="common.department" /></Table.HeaderCell>
                                        <Table.HeaderCell colSpan={3}><FormattedMessage id="common.studyProgram" /></Table.HeaderCell>
                                        {/*<Table.HeaderCell colSpan={2}><FormattedMessage id="common.studyType" /></Table.HeaderCell>*/}
                                        <Table.HeaderCell colSpan={2}><FormattedMessage id="common.applicationDate" /></Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {currentPosts.map((el, index) =>
                                    (<Table.Row key={index}>
                                        <Table.Cell colSpan={1} verticalAlign="middle">
                                            {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                        </Table.Cell>
                                        <Table.Cell colSpan={3} verticalAlign="middle">
                                            <Grid columns={1} centered className="stackable">
                                                <Grid.Row verticalAlign="middle">
                                                    <Grid.Column width="10">
                                                        <span >{el.lastName} {el.firstName}</span>
                                                    </Grid.Column>
                                                    <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                        {/*<span style={{ color: '#a6a4a1' }}>{el.index}</span>*/}
                                                        <span style={{ color: '#a6a4a1' }}>{el.index}</span>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                            {/*{el.studentLastName} {el.studentFirstName}*/}
                                        </Table.Cell>
                                        <Table.Cell colSpan={2} verticalAlign="middle">
                                            {el.departments.map(el => (<div>{el.name}</div>))}
                                        </Table.Cell>
                                        <Table.Cell colSpan={3} verticalAlign="middle">
                                            {/*{el.studyProgramBasicName ? el.studyProgramBasicName : el.departments ? el.departments.map(e => <div>{e.name}</div>) : el.studyProgramName}*/}
                                            {/*{ el.studyProgramDisplayName}*/}
                                            <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                        </Table.Cell>
                                        {/*<Table.Cell colSpan={2} verticalAlign="middle">*/}
                                        {/*    {el.studyType}*/}
                                        {/*</Table.Cell>*/}
                                        <Table.Cell colSpan={2} verticalAlign="middle">
                                            {moment(el.applicationDate).format('D. M. YYYY.')}
                                        </Table.Cell>
                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                            : <NoDataMessage />
                        }

                        {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                        <ToastContainer hideProgressBar />
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/RegisteredStudents.js